/**
 * Composition method for panel module
 * 
 * Author: Sahil David
 */
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { analyticsClickElmTrack } from '@/core/modules/analytics/services/analytics.click.track';

export function panelComposition () {
	const store = useStore();
	const route = useRoute();

	// Computed store value
	const panel = computed((): string => store.getters.get_panel);

	watch(() => route.path, () => {
		processPanel();
	})

	// Process panel toggle
	function processPanel (key = ''): void {
		store.dispatch('axn_updatePanel', key);

		if (!key) { return; }
		analyticsClickElmTrack({
			name: 'panel',
			id: key
		})
	}

	return { panel, processPanel }
}